var aCallable = require('../internals/a-callable');
var anObject = require('../internals/an-object');

module.exports = function (obj) {
  return {
    iterator: obj,
    next: aCallable(anObject(obj).next)
  };
};



//////////////////
// WEBPACK FOOTER
// /tmp/build_310c34ba/node_modules/core-js/internals/get-iterator-direct.js
// module id = 483
// module chunks = 2